import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  namespaced: true,
  actions: {
    aboutCacheValues: function aboutCacheValues(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dispatch, _ref2, _ref2$codes, codes, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$codes = _ref2.codes, codes = _ref2$codes === void 0 ? '' : _ref2$codes;
              _context.next = 4;
              return api.aboutCacheValues({
                codes: codes
              });
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};